// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2K6jD","label":"Completed_label__14HOZ"};